import React from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
    return (
        <div>
            <h1>JAIS Ai</h1>

            <pre>Sistem aduan JAIS</pre>

        </div>
    );
};

export default HomePage;